import { lazy } from "react"
import { Navigate } from "react-router-dom"
// project import
import Loadable from "components/Loadable"
import MainLayout from "layout/MainLayout"
import { ToUserOrAdminLogin } from "helper/helper"

// render - dashboard
const AdminDefault = Loadable(
  lazy(() => import("pages/AdminPages/adminDefault"))
)
const DepartmentsAsPlaces = Loadable(
  lazy(() => import("pages/AdminPages/departments"))
)
const SourcePage = Loadable(lazy(() => import("pages/AdminPages/source")))

const PracticePage = Loadable(lazy(() => import("pages/AdminPages/practices")))

const Providers = Loadable(lazy(() => import("pages/AdminPages/providers")))

// ==============================|| MAIN ROUTING ||============================== //

const AdminRoutes = (isAuthenticated) => {
  return {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: isAuthenticated ? (
          <Navigate to="/admin" replace />
        ) : (
          <ToUserOrAdminLogin />
        ),
        index: true,
      },
      {
        path: "/admin",
        element: isAuthenticated ? <AdminDefault /> : <ToUserOrAdminLogin />,
      },
      {
        path: "/admin/Providers&Departments",
        element: isAuthenticated ? (
          <DepartmentsAsPlaces />
        ) : (
          <ToUserOrAdminLogin />
        ),
      },
      {
        path: "/admin/providers",
        element: isAuthenticated ? <Providers /> : <ToUserOrAdminLogin />,
      },
      {
        path: "/admin/source",
        element: isAuthenticated ? <SourcePage /> : <ToUserOrAdminLogin />,
      },
      {
        path: "/admin/practice",
        element: isAuthenticated ? <PracticePage /> : <ToUserOrAdminLogin />,
      },
      {
        path: "*",
        element: <Navigate to="/admin" replace />,
      },
    ],
  }
}

export default AdminRoutes
